import { render, staticRenderFns } from "./PdpProductImageZoom.vue?vue&type=template&id=4e74afb5&scoped=true&"
import script from "./PdpProductImageZoom.vue?vue&type=script&lang=js&"
export * from "./PdpProductImageZoom.vue?vue&type=script&lang=js&"
import style0 from "./PdpProductImageZoom.vue?vue&type=style&index=0&id=4e74afb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74afb5",
  null
  
)

export default component.exports